class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
      console.log("testvalu",element);
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    // document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }
    if(document.getElementsByClassName("wrapper_all_in_one")){
      
        const targetWrapElement = target.querySelector('.wrapper_all_in_one');
        const sourceWrapElement = source.querySelector('.wrapper_all_in_one');
      
      if (sourceWrapElement && targetWrapElement) {
          const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
          if (isShowingMore) {
            sourceWrapElement
              .querySelectorAll('.facets__item.hidden')
              .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
          }
    
          targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
        }
    }else{
      const targetWrapElement = target.querySelector('.facets-wrap');
        const sourceWrapElement = source.querySelector('.facets-wrap');
    
        if (sourceWrapElement && targetWrapElement) {
          const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
          if (isShowingMore) {
            sourceWrapElement
              .querySelectorAll('.facets__item.hidden')
              .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
          }
    
          targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
        }
    }
    
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/*start code for filter click any open first summary*/

  
  // $(".reset-custom").click(function(){
  //   console.log("ave chhe");
  //    // return false;
  // });
// if($(".filter-label-wrapper details").hasClass("first-filter-details")){
  
// }
// else{
//   $(".filter-label-wrapper details").click(function(){
//   $(".filter-label-wrapper details .reset-custom").click(function(){
//     return false;
//   });
//   // console.log("this",$(this));
//   if(!$(this).hasClass("first-filter-details")){
//       // console.log("its if");
//     if($(this).attr("open")){  
//       // console.log("its insideif");
//       $(this).attr("open","false");
//         $(".filter-label-wrapper details.first-filter-details").removeAttr("open");
//         $(".filter-label-wrapper details.first-filter-details .first-filter-summary").attr("aria-expanded","false");
//     }
//     else{
//       // console.log("its insideelse");
//       $(this).attr("open","false");
//       // $(this).children().attr("aria-expanded","false");
//       // console.log("endelse",$(this).children().css("z-index","3"));
//       $(".filter-label-wrapper details.first-filter-details").attr("open","open");
//       $(".filter-label-wrapper details.first-filter-details .first-filter-summary").attr("aria-expanded","true");
//       // console.log("abcd",$(".filter-label-wrapper details.first-filter-details .first-filter-summary:before"));
//       // this.removeAttribute("open");
//       // this.children.setAttribute("aria-expanded","false");
//     }
//   }
//   else{
//       console.log("its else");
//     if($(this).attr("open")){  
//       // $(this).attr("open","false");
//       $(".filter-label-wrapper details.first-filter-details").attr("open","open");
//       $(".filter-label-wrapper details.first-filter-details .first-filter-summary").attr("aria-expanded","true");
//       // this.removeAttribute("open");
//       // this.children.setAttribute("aria-expanded","false");
//     }
//     else{
//       $(this).attr("open","false");
//         $(".filter-label-wrapper details.first-filter-details").removeAttr("open");
//         $(".filter-label-wrapper details.first-filter-details .first-filter-summary").attr("aria-expanded","false");
//     }
    
//   }
// });
// }
 $(".filter-label-wrapper .other-filter-details").click(function(){
  $(".other-filter-details .other-reset-custom").click(function() {
    console.log($(this).parent().parent());
    return false;
  });
   // if($(".filter-label-wrapper .other-filter-details .reset-custom").hasClass("remove-button-click")){
   // }
      $(this).children().attr("aria-expanded","false");
      $(this).attr("open","false");
      $(".filter-label-wrapper details.first-filter-details").attr("open","open");
      $(".filter-label-wrapper details.first-filter-details .first-filter-summary").attr("aria-expanded","true");
 });

/* start filter- apply button click */
 // $(".filter-apply-all-button").click(function(){
 //   $(".filter-label-wrapper details.first-filter-details").removeAttr("open");
 // });
function applyallclicked(){
   $(".filter-label-wrapper details.first-filter-details").removeAttr("open");
}
/* end filter- apply button click */

//start search custom

// document.getElementById('collection-search-input').addEventListener('input', function () {
//         const query = this.value.toLowerCase();
//         const products = document.querySelectorAll('#collection-product-list .product-item');

//         products.forEach(product => {
//             const title = product.textContent.toLowerCase();
//             if (title.includes(query)) {
//                 product.style.display = 'block';
//             } else {
//                 product.style.display = 'none';
//             }
//         });
//     });

// document.addEventListener('DOMContentLoaded', () => {
//   const searchInput = document.getElementById('search-title');
//   const searchButton = document.getElementById('search-button');
//   const productItems = document.querySelectorAll('.product-item');

//   const filterProducts = () => {
//     const query = searchInput.value.toLowerCase();
//     productItems.forEach((item) => {
//       const title = item.getAttribute('data-title');
//       if (title.includes(query)) {
//         item.style.display = '';
//       } else {
//         item.style.display = 'none';
//       }
//     });
//   };

//   searchButton.addEventListener('click', filterProducts);
//   searchInput.addEventListener('keyup', (event) => {
//     if (event.key === 'Enter') {
//       filterProducts();
//     }
//   });
// });


// Get the search bar and filter elements
// const searchBar = document.getElementById('search-bar');
// const filterButton = document.getElementById('filter-button');

// // Add event listener to the filter button
// filterButton.addEventListener('click', () => {
//   // Get the search query and filter value
//   const searchQuery = searchBar.value;
//   const filterValue = document.getElementById('filter-value').value;

//   // Apply the filter using Shopify's API
//   fetch('/collections/' + collectionHandle + '/products.json', {
//     method: 'GET',
//     headers: {
//       'Content-Type': 'application/json'
//     },
//     params: {
//       'title': searchQuery,
//       'filter': filterValue
//     }
//   })
//   .then(response => response.json())
//   .then(data => {
//     // Update the product list with the filtered results
//     const productList = document.getElementById('product-list');
//     productList.innerHTML = '';
//     data.products.forEach(product => {
//       const productHTML = `
//         <div>
//           <h2>${product.title}</h2>
//           <p>${product.description}</p>
//           <p>Price: ${product.price}</p>
//         </div>
//       `;
//       productList.innerHTML += productHTML;
//     });
//   })
//   .catch(error => console.error(error));
// });

//working some seconds  start
// document.addEventListener('DOMContentLoaded', function () {
//   const searchInput = document.getElementById('collection-search-input');
//   const productCards = document.querySelectorAll('.grid__item');

//   searchInput.addEventListener('input', function () {
//     const query = searchInput.value.toLowerCase();
//     productCards.forEach((card) => {
//       const productTitle = card.getAttribute('data-title');
//       if (productTitle.includes(query)) {
//         card.style.display = 'block'; // Show the product
//       } else {
//         card.style.display = 'none'; // Hide the product
//       }
//     });
//   });
//   return false;
// });
//working some seconds  end

//end search custom
/*end code for filter click any open first summary*/